import { FirebaseAnalytics } from '@capacitor-firebase/analytics';
import { Capacitor } from '@capacitor/core';
import { UserProfile } from '../types/user';
import { userCache } from '../utils/user-cache';

class AnalyticsService {
  async setUserProperties(userInfo: UserProfile) {
    if (!Capacitor.isNativePlatform()) {
      return;
    }
    const userId = userInfo?.id;
    if (!userId) {
      return;
    }
    const username = userInfo?.username;
    const activeProfile = userCache.getActiveProfile();
    // @ts-expect-error - should emis be defined in GenericProfile interface?
    const activeProfileEmis = activeProfile?.emis;
    const activeProfileId = activeProfile?.id;
    const activeProfileRole = activeProfile?.role;

    await FirebaseAnalytics.setUserId({
      userId: userId.toString(),
    });

    const properties = [
      { key: 'userId', value: userId?.toString() },
      { key: 'username', value: username },
      { key: 'activeProfileEmis', value: activeProfileEmis?.toString() },
      { key: 'activeProfileId', value: activeProfileId?.toString() },
      { key: 'activeProfileRole', value: activeProfileRole },
    ];

    for (const property of properties) {
      if (property.value) {
        await FirebaseAnalytics.setUserProperty(property);
      }
    }
  }
}

export const firebaseAnalyticsService = new AnalyticsService();
